import React from 'react'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'
import DmtcommschList from './dmtcommschList/DmtcommschList'

function BbpsCommSche() {
 
  return (
    <>
    <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Commision",
    title_2: "BBPS Commision",
  }}/>
    <DmtcommschList/>
    </>

  )
}

export default BbpsCommSche